import { useSearchParams } from "react-router-dom";
import { Phone } from "lucide-react";
import { Seo, breadcrumbSchema } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { QuoteForm } from "../components/forms/QuoteForm";
import { HoursList } from "../components/site/Location";
import { OpenBadge } from "../components/site/OpenBadge";
import { SITE, TEL } from "../lib/site";

export default function Devis() {
  const [params] = useSearchParams();
  const rdv = params.get("mode") === "rendez-vous";
  const crumbs = [{ to: "/", label: "Accueil" }, { to: "/devis", label: rdv ? "Prendre rendez-vous" : "Demande de devis" }];
  return (
    <>
      <Seo
        title={rdv ? "Prendre rendez-vous pare-brise Haguenau | A+ Glass Haguenau" : "Demande de devis pare-brise Haguenau | A+GLASS Pare-Brise HAGUENAU"}
        description="Demandez votre devis ou votre rendez-vous en ligne : pare-brise, impact, vitrage, calibration ADAS, rénovation d'optiques à Haguenau. Ajoutez une photo du dommage."
        path="/devis"
        schemas={[breadcrumbSchema(crumbs)]}
      />
      <PageHero eyebrow={rdv ? "Rendez-vous en ligne" : "Devis en ligne"} title={rdv ? "Prendre rendez-vous" : "Demande de devis"} crumbs={crumbs}
        intro="Remplissez le formulaire, joignez une photo si possible : notre équipe de Haguenau revient vers vous rapidement pendant nos horaires d'ouverture." />
      <section className="px-5 py-16 lg:px-8">
        <div className="mx-auto grid max-w-[1320px] gap-10 lg:grid-cols-12">
          <div className="lg:col-span-8"><QuoteForm key={rdv ? "rdv" : "devis"} /></div>
          <aside className="space-y-4 lg:col-span-4">
            <div className="rounded-[1.75rem] bg-ag-ink p-7 text-white lg:sticky lg:top-28">
              <p className="font-display text-xl font-extrabold">Plus rapide par téléphone</p>
              <a href={TEL} className="btn btn-blue mt-5 w-full justify-center" data-testid="devis-call-button"><Phone className="h-4 w-4" />{SITE.phone}</a>
              <div className="mt-6 rounded-2xl bg-white p-5 text-ag-ink">
                <div className="mb-2 flex items-center justify-between"><span className="font-bold">Horaires</span><OpenBadge testid="devis-open-badge" /></div>
                <HoursList />
              </div>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
